export default "__VITE_ASSET__Crg1JRC0__"